import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as config from "../../../../../constants/config";
import * as handlers from "../../../../../constants/handlers";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as rccActions from "../../../../../actions/rccActions";
import * as formatHelper from "../../../../../helpers/formatHelper";
import * as modelHelper from "../../../../../helpers/modelHelper";
import * as translationHelper from "../../../../../helpers/translationHelper";

import Table, {TABLE_VARIANT_SECONDARY} from "../../../../global/generic/Table";
import Modal from "../../../../global/generic/Modal";

import imgLoader from "../../../../../resources/img/loader.svg";

class MachineFillCanisterHistoryModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            offset: 0,
            listLength: 0
        };
    }

    componentDidMount() {
        this.props.dispatchInitCanisterRefillHistoryAction();
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseMachineFillCanisterHistoryModalAction();
    };

    handleHistoryScroll = (event) => {
        if (
            Math.ceil(event.target.scrollHeight) === Math.ceil(event.target.scrollTop + event.target.clientHeight) &&
            this.state.offset <= this.props.refillHistory.length &&
            this.state.listLength < this.props.refillHistory.length
        ) {
            this.props.dispatchGetMachineRefillHistoryAction(this.state.offset + config.MAX_COLORANT_LIMIT);
            this.setState({
                offset: this.state.offset + config.MAX_COLORANT_LIMIT,
                listLength: this.props.refillHistory.length
            });
        }
    };

    getTableHeader = () => {
        return modelHelper.buildTableRow([
            modelHelper.buildTableCell(<Translate value="general.date" />),
            modelHelper.buildTableCell(<Translate value="general.canister" />),
            modelHelper.buildTableCell(<Translate value="customRedlike.volume" />),
            modelHelper.buildTableCell(<Translate value="general.type" />)
        ]);
    };

    getTableColumns = () => {
        return [
            modelHelper.buildTableColumn("col-4 text-center"),
            modelHelper.buildTableColumn("col-2 text-center"),
            modelHelper.buildTableColumn("col-2 text-center"),
            modelHelper.buildTableColumn("col-4 text-center")
        ];
    };

    getTableRows = () => {
        return this.props.refillHistory.map((record) => {
            return modelHelper.buildTableRow(
                [
                    modelHelper.buildTableCell(formatHelper.formatDateTimeUtc(record.date)),
                    modelHelper.buildTableCell(record.index),
                    modelHelper.buildTableCell(formatHelper.formatDecimal(record.amount)),
                    modelHelper.buildTableCell(translationHelper.formatRefillType(record.type))
                ],
                "",
                record.id
            );
        });
    };

    getTable = () => {
        if (!this.props.machine.isConnected) {
            return null;
        }

        if (this.props.loading) {
            return (
                <div className="loader width-100 text-align-center">
                    <img alt="loading" src={imgLoader} />
                </div>
            );
        }

        return (
            <Table
                variant={TABLE_VARIANT_SECONDARY}
                tableHeader={this.getTableHeader()}
                tableRows={this.getTableRows()}
                tableColumns={this.getTableColumns()}
                onScroll={this.handleHistoryScroll}
            />
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("customRedlike.fillCanisterHistory"))}
                content={modelHelper.buildModalSection(this.getTable())}
                styles={{height: "80%", minWidth: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        machine: store.rcc.machine,
        refillHistory: store.machine.refillHistory,
        loading: store.rcc.requests.some((request) => request.method === handlers.MACHINE_HISTORY_REFILLS)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseMachineFillCanisterHistoryModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_MACHINE_FILL_CANISTER_HISTORY_MODAL));
        },
        dispatchInitCanisterRefillHistoryAction: () => {
            dispatch(rccActions.getCanisterRefillHistory(null));
        },
        dispatchGetMachineRefillHistoryAction: (offset) => {
            dispatch(rccActions.getMachineRefillHistoryWithOffset(null, offset));
        }
    };
};

export default MachineFillCanisterHistoryModal = connect(
    mapStoreToProps,
    mapDispatchToProps
)(MachineFillCanisterHistoryModal);
